// extracted by mini-css-extract-plugin
module.exports = {"link":"FintoLink_link__3M5oi","link__wrapper":"FintoLink_link__wrapper__3uJM7"};